import styled from "styled-components";
import PropTypes from "prop-types";

const Wrapper = styled('div')`
  width: 100%;
  background: inherit;
  padding: ${({hasStatusBar, hasFixedBar, top, bottom, list}) => list ? '54px 8px' : hasStatusBar ? hasFixedBar ? `54px 8px ${bottom || '55px'} 8px` : `${top || '54px'} 8px 6px 8px` : '0 8px 6px 8px'};

  .row {
    margin: 0 !important;
  }
`

const Container = (props) => {
  const { children, hasStatusBar, hasFixedBar, top, bottom, list} = props
  return (
    <Wrapper hasStatusBar={hasStatusBar} hasFixedBar={hasFixedBar} top={top} bottom={bottom} list={list}>
      {children}
    </Wrapper>
  )
}

Container.propTypes = {
  children: PropTypes.any.isRequired,
  hasStatusBar: PropTypes.bool,
  top: PropTypes.string,
  bottom: PropTypes.string,
  hasFixedBar: PropTypes.bool,
  list: PropTypes.bool,
}

export default Container
